import { Observable } from 'rxjs';
import { ListaUsuariosResponseDTO } from 'src/app/data/dto/UsuariosDTO';

export abstract class UsuariosRepository {
    abstract listaUsuarios(): Observable<ListaUsuariosResponseDTO>;
}
